/* BaseScheduleComponent.js */

"use strict";
const EventEmitter = require("events").EventEmitter;

const oneMinute = 60 * 1000;
const oneHour = 60 * oneMinute;
const fiveMinutes = 5 * oneMinute;
const fifteenMinutes = 15 * oneMinute;
const oneHourAndFiveMinutes = oneHour + fiveMinutes;

class BaseScheduleComponent extends EventEmitter {
    constructor(Renderer, scheduleComp, ...renderProps) {
        super();
        this._renderer = new Renderer(scheduleComp || this, renderProps);
    }
    shutdown() {
        return this._renderer
            .shutdown()
            .then(() => {
                this._renderer = undefined;
            })
            .catch((err) => {
                console.error(err);
            });
    }
    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }

    get theme() {
        return this.getTheme();
    }
    getTheme() {
        return this._theme;
    }
    set theme(theme) {
        this.setTheme(theme);
    }

    static getNextFiveMinuteTimeFromNow() {
        let now = Date.now();
        let nextTime = now - (now % fifteenMinutes) + fifteenMinutes;
        if (nextTime - now < fiveMinutes) {
            nextTime += fifteenMinutes;
        }

        return new Date(nextTime);
    }

    static getNextOneHourTimeFromNow() {
        let now = Date.now();
        now += oneHourAndFiveMinutes;
        return new Date(now);
    }

    setTheme(theme) {
        let oldTheme = this._theme;
        this._theme = theme;
        this.emit("Theme", this._theme, oldTheme);
    }
}

module.exports = BaseScheduleComponent;
